import React from "react";
import { TrendingUp, Bell, Shield, PieChart, Layers, Receipt } from "lucide-react";
import { Biz360Logo } from "./Biz360Logo";

// Composant Features (pour réutilisation mobile/desktop)
const FeaturesList = ({ compact = false }) => (
  <ul className={compact ? "space-y-3" : "space-y-5"}>
    <li className="flex items-start gap-3">
      <div className={`${compact ? "w-7 h-7" : "w-9 h-9"} rounded-full bg-white/20 flex items-center justify-center flex-shrink-0 mt-0.5`}>
        <Receipt size={compact ? 14 : 18} />
      </div>
      <div>
        <span className="font-semibold">Gestion intelligente de la TVA</span>
        {!compact && <p className="text-sm opacity-80">Seuils, assujettissement, échéances... on gère tout pour toi</p>}
        {!compact && <span className="inline-block mt-1 text-xs px-2 py-0.5 rounded-full bg-white/20 text-white">✨ Nouveau</span>}
      </div>
    </li>
    <li className="flex items-start gap-3">
      <div className={`${compact ? "w-7 h-7" : "w-9 h-9"} rounded-full bg-white/20 flex items-center justify-center flex-shrink-0 mt-0.5`}>
        <Layers size={compact ? 14 : 18} />
      </div>
      <div>
        <span className="font-semibold">Double activité ? On gère.</span>
        {!compact && <p className="text-sm opacity-80">Ventes + Prestations, chaque CA à sa place</p>}
      </div>
    </li>
    <li className="flex items-start gap-3">
      <div className={`${compact ? "w-7 h-7" : "w-9 h-9"} rounded-full bg-white/20 flex items-center justify-center flex-shrink-0 mt-0.5`}>
        <PieChart size={compact ? 14 : 18} />
      </div>
      <div>
        <span className="font-semibold">Cotisations calculées automatiquement</span>
        {!compact && <p className="text-sm opacity-80">Urssaf, CFP, versement libératoire... zéro prise de tête</p>}
      </div>
    </li>
    <li className="flex items-start gap-3">
      <div className={`${compact ? "w-7 h-7" : "w-9 h-9"} rounded-full bg-white/20 flex items-center justify-center flex-shrink-0 mt-0.5`}>
        <Bell size={compact ? 14 : 18} />
      </div>
      <div>
        <span className="font-semibold">Alertes personnalisées</span>
        {!compact && <p className="text-sm opacity-80">Déclarations, seuils TVA, CFE... tu es toujours prévenu(e)</p>}
      </div>
    </li>
    <li className="flex items-start gap-3">
      <div className={`${compact ? "w-7 h-7" : "w-9 h-9"} rounded-full bg-white/20 flex items-center justify-center flex-shrink-0 mt-0.5`}>
        <Shield size={compact ? 14 : 18} />
      </div>
      <div>
        <span className="font-semibold">100% conforme 2026</span>
        {!compact && <p className="text-sm opacity-80">Taux et seuils officiels, toujours à jour</p>}
      </div>
    </li>
  </ul>
);

// Auth Layout (pour Login/Register)
export const AuthLayout = ({ children }) => (
  <div className="min-h-screen flex flex-col lg:flex-row">
    {/* Section mobile - Bannière en haut sur mobile */}
    <div className="lg:hidden bg-gradient-to-br from-primary to-primary/80 p-6 text-primary-foreground">
      <div className="flex items-center gap-3 mb-4">
        <Biz360Logo size={52} />
      </div>
      <h2 className="text-lg font-bold mb-2">Le copilote de ton auto-entreprise</h2>
      <p className="text-sm opacity-90 mb-4">Biz360 ❤️‍🔥 t'aide à piloter ton activité sans prise de tête !</p>
      <FeaturesList compact />
    </div>
    
    {/* Section formulaire */}
    <div className="flex-1 flex items-center justify-center p-6 sm:p-8 bg-background">
      <div className="w-full max-w-md">{children}</div>
    </div>
    
    {/* Section desktop - Panneau de droite sur desktop */}
    <div className="hidden lg:flex flex-1 bg-gradient-to-br from-primary to-primary/80 items-center justify-center p-12">
      <div className="text-primary-foreground max-w-md">
        <Biz360Logo size={72} />
        <h2 className="text-2xl font-bold mt-6 mb-2">Le copilote de ton auto-entreprise</h2>
        <p className="text-lg opacity-90 mb-8">Biz360 ❤️‍🔥 t'aide à piloter ton activité au quotidien, sans prise de tête !</p>
        <FeaturesList />
      </div>
    </div>
  </div>
);
